import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import toast from './modules/toast';
import sidebar from './modules/sidebar';
import pageTitle from './modules/pageTitle';
import breadcrumb from './modules/breadcrumb';
import auth from './modules/auth';
import me from './modules/me';
import meUpdate from './modules/meUpdate';
import userList from './modules/userList';
import userSingle from './modules/userSingle';
import userCreate from './modules/userCreate';
import userUpdate from './modules/userUpdate';
import orderList from './modules/orderList';
import orderSingle from './modules/orderSingle';
import orderDoc from './modules/orderDoc';
import orderDocMultiple from './modules/orderDocMultiple';
import orderStatusUpdate from './modules/orderStatusUpdate';
import orderStatusMultipleUpdate from './modules/orderStatusMultipleUpdate';
import stockBrowserSkuList from './modules/stockBrowserSkuList';
import stockBrowserSkuSingle from './modules/stockBrowserSkuSingle';
import stockBrowserSkuBranchList from './modules/stockBrowserSkuBranchList';
import stockBrowserBranchList from './modules/stockBrowserBranchList';
import stockBrowserBranchSingle from './modules/stockBrowserBranchSingle';
import stockBrowserBranchSkuList from './modules/stockBrowserBranchSkuList';
import brandList from './modules/brandList';
import locationList from './modules/locationList';
import branchList from './modules/branchList';
import channelList from './modules/channelList';
import channelSingle from './modules/channelSingle';
import channelCreate from './modules/channelCreate';
import channelUpdate from './modules/channelUpdate';
import channelDelete from './modules/channelDelete';
import categoryList from './modules/categoryList';
import categorySelector from './modules/categorySelector';
import stockRuleList from './modules/stockRuleList';
import stockRuleSingle from './modules/stockRuleSingle';
import stockRuleCreate from './modules/stockRuleCreate';
import stockRuleUpdate from './modules/stockRuleUpdate';
import stockRuleDelete from './modules/stockRuleDelete';
import channelRuleList from './modules/channelRuleList';
import channelRuleSingle from './modules/channelRuleSingle';
import channelRuleCreate from './modules/channelRuleCreate';
import channelRuleUpdate from './modules/channelRuleUpdate';
import channelRuleDelete from './modules/channelRuleDelete';
import branchGroupList from './modules/branchGroupList';
import branchGroupAssignList from './modules/branchGroupAssignList';
import branchGroupAssignUpdate from './modules/branchGroupAssignUpdate';
import dashboard from './modules/dashboard';
import report from './modules/report';
import error from './modules/error';
import auditLogs from './modules/auditLogs';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		// ui
		app,
		toast,
		sidebar,
		pageTitle,
		breadcrumb,

		// api
		auth,
		me,
		meUpdate,
		userList,
		userSingle,
		userCreate,
		userUpdate,
		orderList,
		orderSingle,
		orderDoc,
		orderDocMultiple,
		orderStatusUpdate,
		orderStatusMultipleUpdate,
		stockBrowserSkuList,
		stockBrowserSkuSingle,
		stockBrowserSkuBranchList,
		stockBrowserBranchList,
		stockBrowserBranchSingle,
		stockBrowserBranchSkuList,
		brandList,
		locationList,
		branchList,
		channelList,
		channelSingle,
		channelCreate,
		channelUpdate,
		channelDelete,
		categoryList,
		categorySelector,
		stockRuleList,
		stockRuleSingle,
		stockRuleCreate,
		stockRuleUpdate,
		stockRuleDelete,
		channelRuleList,
		channelRuleSingle,
		channelRuleCreate,
		channelRuleUpdate,
		channelRuleDelete,
		branchGroupList,
		branchGroupAssignList,
		branchGroupAssignUpdate,
		dashboard,
		report,
		error,
		auditLogs,
	},
});
